export const pdaRegistryConst = [
  { label: "Contenzioso Civile", value: "CC", type: "SICID" },
  { label: "Diritto del Lavoro", value: "LAV", type: "SICID" },
  { label: "Volontaria Giurisdizione", value: "VG", type: "SICID" },
  // { label: "MIN", value: "MIN" , type: "SICID"},
  { label: "Procedure Concorsuali", value: "FALL", type: "SIECIC" },
  { label: "Esecuzioni Mobiliari", value: "ESM", type: "SIECIC" },
  { label: "Esecuzioni Immobiliari", value: "ESIM", type: "SIECIC" },
  { label: "Procedimenti davanti al Giudice di Pace", value: "GDP", type: "SIGP" },
  { label: "Registro Civile della Cassazione", value: "CASSCI", type: "CASSCI" }
];